import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useConnect } from '../context/ConnectContext';
import { IMAGES } from '../data/mock';

export default function CTASection() {
  const { openConnect } = useConnect();
  return (
    <section className="relative overflow-hidden py-24">
      <div className="absolute inset-0">
        <img src={IMAGES.goldenSunset} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-farmway-green/90" />
      </div>
      <div className="container-fw relative text-center">
        <span className="eyebrow">Get in touch</span>
        <h2 className="mx-auto mt-4 max-w-3xl display-xl text-4xl text-farmway-cream sm:text-5xl lg:text-6xl">
          Interested in farmland <span className="text-farmway-gold">investing?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg text-farmway-cream/75">
          Get in touch now to find out more about future-proof farmland and agribusiness with Farmway.
        </p>
        <button onClick={openConnect} className="btn-gold mx-auto mt-9">
          Connect with us <ArrowUpRight className="h-4 w-4" />
        </button>
      </div>
    </section>
  );
}
